import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49f282fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { key: 0 }

import { withDefaults } from 'vue';

import {
  useChipClasses,
  useCloseIconClasses,
} from './composables/useChipStyles';

import BalIcon from '../BalIcon/BalIcon.vue';

type Props = {
  label?: string;
  closeable?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'zink' | 'gradient' | 'white' | 'red';
  outline?: boolean;
  rounded?: boolean;
};

/**
 * PROPS & EMITS
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BalChip',
  props: {
    label: { default: '' },
    closeable: { type: Boolean, default: false },
    size: { default: 'md' },
    color: { default: 'zink' },
    outline: { type: Boolean, default: true },
    rounded: { type: Boolean, default: false }
  },
  emits: ['closed'],
  setup(__props: any, { emit }) {

const props = __props as { label: string, closeable: boolean, size: 'sm' | 'md' | 'lg', color: 'zink' | 'gradient' | 'white' | 'red', outline: boolean, rounded: boolean };





const classes = useChipClasses(props);
const { classes: iconClasses, iconSize } = useCloseIconClasses(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['bal-chip', _unref(classes)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.label), 1))
        : _renderSlot(_ctx.$slots, "default", { key: 1 }),
      (__props.closeable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closed')))
          }, [
            _createVNode(BalIcon, {
              name: "gridicons:cross-small",
              size: _unref(iconSize),
              class: _normalizeClass(['close', _unref(iconClasses)])
            }, null, 8, ["size", "class"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})